import { c as _c } from "react/compiler-runtime";
import type { OnboardingRequirementSelectConditionalBranch } from '@onefootprint/request-types';
import { Form, PageShell } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
type FormData = {
  selectedBranch: string;
};
type SelectConditionalBranchProps = {
  currentRequirement: OnboardingRequirementSelectConditionalBranch;
  isLoading: boolean;
  onSubmit: (chosenSuccessorId: string) => void;
};
export const SelectConditionalBranch = t0 => {
  const $ = _c(47);
  const {
    currentRequirement,
    isLoading,
    onSubmit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "selectConditionalBranch"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t1);
  const {
    availableBranches,
    nodeName,
    rulesSuccessorId
  } = currentRequirement;
  const t2 = availableBranches[0]?.successorId ?? "";
  let t3;
  if ($[1] !== t2) {
    t3 = {
      defaultValues: {
        selectedBranch: t2
      }
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const methods = useForm(t3);
  let t4;
  if ($[3] !== onSubmit) {
    t4 = data => {
      onSubmit(data.selectedBranch);
    };
    $[3] = onSubmit;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const handleSubmit = t4;
  let t5;
  if ($[5] !== availableBranches) {
    t5 = availableBranches.map(_temp);
    $[5] = availableBranches;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const options = t5;
  let t6;
  if ($[7] !== handleSubmit || $[8] !== methods) {
    t6 = methods.handleSubmit(handleSubmit);
    $[7] = handleSubmit;
    $[8] = methods;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t) {
    t7 = t(_temp2);
    $[10] = t;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = nodeName ?? "Rules";
  let t9;
  if ($[12] !== t || $[13] !== t8) {
    t9 = t(_temp3, {
      rulesNodeName: t8
    });
    $[12] = t;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t(_temp4);
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = {
      text: t10,
      type: "submit"
    };
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== isLoading || $[20] !== onSubmit || $[21] !== rulesSuccessorId || $[22] !== t) {
    t12 = rulesSuccessorId ? {
      text: t(_temp5),
      type: "button",
      variant: "link",
      disabled: isLoading,
      onClick: () => onSubmit(rulesSuccessorId)
    } : undefined;
    $[19] = isLoading;
    $[20] = onSubmit;
    $[21] = rulesSuccessorId;
    $[22] = t;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t) {
    t13 = t(_temp6);
    $[24] = t;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = t(_temp7);
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = {
      required: t14
    };
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== options || $[31] !== t13 || $[32] !== t15) {
    t16 = <div className="flex flex-col gap-4 w-full"><Form.Select name="selectedBranch" label={t13} options={options} rules={t15} /></div>;
    $[30] = options;
    $[31] = t13;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  let t17;
  if ($[34] !== isLoading || $[35] !== t11 || $[36] !== t12 || $[37] !== t16 || $[38] !== t7 || $[39] !== t9) {
    t17 = <PageShell title={t7} subtitle={t9} cta={t11} secondaryCta={t12} isLoading={isLoading}>{t16}</PageShell>;
    $[34] = isLoading;
    $[35] = t11;
    $[36] = t12;
    $[37] = t16;
    $[38] = t7;
    $[39] = t9;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t17 || $[42] !== t6) {
    t18 = <form onSubmit={t6}>{t17}</form>;
    $[41] = t17;
    $[42] = t6;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== methods || $[45] !== t18) {
    t19 = <FormProvider {...methods}>{t18}</FormProvider>;
    $[44] = methods;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  return t19;
};
function _temp(branch) {
  return {
    label: branch.name,
    value: branch.successorId
  };
}
function _temp2($) {
  return $.title;
}
function _temp3($_0) {
  return $_0.subtitle;
}
function _temp4($_1) {
  return $_1.cta;
}
function _temp5($_2) {
  return $_2.evaluateRules;
}
function _temp6($_3) {
  return $_3.label;
}
function _temp7($_4) {
  return $_4.required;
}